// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./OptionSelectModal.CloseButton.css";
import React, { createContext, useContext } from "react";
import {
  exists,
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import { RootPrimitive, TextPrimitive } from "../_internal_primitives";

const styles = [
  {
    type: "default",
    layers: {
      WnenmzbykD: {
        none: {
          text: "Cancel",
        },
      },
    },
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
];

const variantPropTypes = [];

export const CloseButtonContext = createContext(null);

function CloseButton(_props) {
  const defaults = useContext(CloseButtonContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RootPrimitive
      {...props}
      key="BjDpeMs5iP"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "BjDpeMs5iP",
        scope: "QfRPhAPUFG",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <TextPrimitive
          id={"Text_WnenmzbykD"}
          className={
            "__visly_reset_7X7HTLRqyD __visly_scope_QfRPhAPUFG_WnenmzbykD"
          }
          key={"WnenmzbykD"}
          text={
            exists(props.text) ? props.text : getStyle("WnenmzbykD", "text")
          }
          element={getStyle("WnenmzbykD", "htmlElement")}
        />
      )}
    </RootPrimitive>
  );
}

CloseButton.__variants = [];

export default CloseButton;
